import moment from "moment";

export const internalFetch = async (input, init) => {
    return fetch(input, init)
        .then((res) => {
            if (!res.ok) {
                const error = new Error("Action failed to complete due to server error");
                error.response = res;
                throw error;
            }

            const contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                return res.json();
            } else {
                return res.text();
            }
        })
        .then((json) => {
            return { err: null, result: json };
        })
        .catch((e) => {
            return { err: e.message, response: e.response, result: null };
        });
};

// Internal fetch that handles fetching from the OData API
export const internalODataFetch = async (input, init) => {
    return fetch(input, init)
        .then((res) => {
            if (!res.ok) {
                // todo: get more details here
                throw new Error("Action failed to complete due to server error");
            }
            // treat the JSON result as text so
            // we can parse the dates
            return res.text();
        })
        .then((result) => {
            // Parse the date values
            if (result !== "") {
                const jsonString = ConvertDateToLocal(result);
                // convert string to JSON and return the results array
                const json = JSON.parse(jsonString);
                if (json?.d?.results != null || json?.d?.results != undefined) {
                    return { err: null, result: json.d.results };
                } else {
                    // Changing as per new response fomrat from Backend.. commenting old code.
                    return { err: null, result: json.body };
                }
            }
            return { err: null, result: [] };
        })
        .catch((e) => {
            return { err: e.message, result: null };
        });
};

const findDateExpr = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}(\+|-)[0-1][0-9]:[0-9]{2}/g;

const ConvertDateToLocal = (odata) => {
    return odata.replace(findDateExpr, (match) => {
        //return '"' + new Date(parseInt(p1)).toISOString() + '"'
        return moment.utc(new Date(match) - new Date().getTimezoneOffset() * 60000).format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
    });
};
